//noScroll
class Facility {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    var swiper = new Swiper('.slide1', {             
      slidesPerView: 1,
      spaceBetween: 30,
      effect: 'fade',
      autoplay: {
        delay: 4000,
      },
      pagination: {
        el: '.swiper-pagination1',
        clickable: true
      },
      // breakpoints: {
      //   769: {
      //     slidesPerView: 3.2,
      //     spaceBetween: 30,
      //   }
      // }
    })
    var swiper = new Swiper('.slide2', {             
      slidesPerView: 1,
      spaceBetween: 30,
      effect: 'fade',
      autoplay: {
        delay: 4000,
      },
      pagination: {
        el: '.swiper-pagination2',
        clickable: true
      },
      // breakpoints: {
      //   769: {
      //     slidesPerView: 3.2,
      //     spaceBetween: 30,
      //   }
      // }
    })
  }
}
